function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m62.932 57.777-25.777-25.777 25.777-25.777a3.6454 3.6454 0 0 0 0-5.1554 3.6454 3.6454 0 0 0-5.1554 0l-25.777 25.777-25.777-25.777a3.6454 3.6454 0 0 0-5.1554 0 3.6454 3.6454 0 0 0 0 5.1554l25.777 25.777-25.777 25.777a3.6454 3.6454 0 0 0 0 5.1554 3.6454 3.6454 0 0 0 5.1554 0l25.777-25.777 25.777 25.777a3.6454 3.6454 0 0 0 5.1554 0 3.6454 3.6454 0 0 0 0-5.1554z",
    fill: "currentColor",
    style: {
      strokeWidth: 3.6454
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseThin);
export default __webpack_public_path__ + "static/media/close-thin.788a88d8.svg";
export { ForwardRef as ReactComponent };